import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class QuestionSettings implements Deserializable<any, QuestionSettings>, Serializable<JsonObject> {
  constructor(
    public valueMax?: number,
    public valueMin?: number,
    public characterLimitMax?: number,
    public characterLimitMin?: number,
    public countMax?: number,
    public countMin?: number,
    public required?: boolean,
    public sliderSnaps?: boolean
  ) {}

  deserialize(input: any): QuestionSettings {
    if (input == null) {
      return null;
    }
    this.valueMax = input.valueMax;
    this.valueMin = input.valueMin;
    this.characterLimitMax = input.characterLimitMax;
    this.characterLimitMin = input.characterLimitMin;
    this.countMax = input.countMax;
    this.countMin = input.countMin;
    this.required = input.required;
    this.sliderSnaps = input.sliderSnaps;
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['valueMax'] = this.valueMax;
    json['valueMin'] = this.valueMin;
    json['characterLimitMax'] = this.characterLimitMax;
    json['characterLimitMin'] = this.characterLimitMin;
    json['countMax'] = this.countMax;
    json['countMin'] = this.countMin;
    json['required'] = this.required;
    json['sliderSnaps'] = this.sliderSnaps;
    return json;
  }
}
